var _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01N(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 317,
    viewBox: "0 0 313 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.745 284.95C139.307 284.952 130.89 284.099 122.623 282.405C106.668 279.119 91.5202 272.712 78.0491 263.553C59.386 250.904 44.4749 233.461 34.883 213.057C25.291 192.653 21.3723 170.043 23.5389 147.601C25.7054 125.16 33.8772 103.716 47.1952 85.5244C60.5133 67.3326 78.4859 53.0642 99.2242 44.2189C106.763 41.016 114.601 38.5707 122.624 36.9189C135.679 34.2479 149.076 33.6741 162.311 35.2189C159.493 41.3823 157.336 47.8274 155.878 54.4459C152.98 67.6791 152.88 81.3718 155.584 94.6459C158.107 106.965 163.031 118.666 170.075 129.083C177.004 139.338 185.835 148.17 196.089 155.1C201.243 158.581 206.721 161.554 212.448 163.979C218.274 166.442 224.33 168.321 230.526 169.591C244.254 172.387 258.424 172.183 272.065 168.991C269.766 200.383 255.739 229.76 232.773 251.284C209.762 272.94 179.344 284.983 147.745 284.95Z",
    fill: "#713FFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.811 142.43C153.793 117.234 162.504 81.2907 145.267 62.1471C128.03 43.0036 91.3724 47.9094 63.3902 73.1046C35.4081 98.2998 26.6974 134.244 43.9344 153.387C61.1713 172.531 97.8286 167.625 125.811 142.43Z",
    fill: "#A586FC"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3521 2L91.4021 12.22L102.352 16L91.4021 19.78L87.3521 30L83.3021 19.78L72.3521 16L83.3021 12.22L87.3521 2Z",
    fill: "url(#paint0_linear_3_30)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.352 242L276.862 250.4L286.352 253.5L276.862 256.6L273.352 265L269.842 256.6L260.352 253.5L269.842 250.4L273.352 242Z",
    fill: "url(#paint1_linear_3_30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.956 34.0109L223.737 41.5852L234.04 42.1973L225.425 47.8816L224.209 57.3321L218.429 49.7585L208.126 49.1464L216.74 43.4611L217.956 34.0109Z",
    fill: "url(#paint2_linear_3_30)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7354 223.403L17.9663 229.272L27.6655 228.306L20.2341 234.614L20.1286 243.173L13.8938 237.3L4.19543 238.267L11.6268 231.96L11.7354 223.403Z",
    fill: "url(#paint3_linear_3_30)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_3_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.507 117.989L205.653 119.383L201.597 126.486L201.066 118.324L195.516 114.066L202.37 112.673L206.425 105.573L206.957 113.735L212.507 117.989Z",
    fill: "url(#paint4_linear_3_30)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_3_30",
    x: 2.95801,
    y: 6.37305,
    width: 309.107,
    height: 310.577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_30",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3_30",
    x: 15.0847,
    y: 30.4692,
    width: 159.031,
    height: 154.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3_30",
    x: 70.3521,
    y: 0,
    width: 34,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3_30",
    x: 258.352,
    y: 240,
    width: 30,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3_30",
    x: 206.126,
    y: 32.0107,
    width: 29.9146,
    height: 27.3213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3_30",
    x: 2.19531,
    y: 221.403,
    width: 27.4702,
    height: 23.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_3_30",
    x: 193.516,
    y: 103.573,
    width: 20.991,
    height: 24.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3_30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_30",
    x1: 87.3521,
    y1: 2,
    x2: 87.3521,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_30",
    x1: 273.352,
    y1: 242,
    x2: 273.352,
    y2: 265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_30",
    x1: 217.956,
    y1: 34.0108,
    x2: 224.209,
    y2: 57.3319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_30",
    x1: 11.7345,
    y1: 223.403,
    x2: 20.1277,
    y2: 243.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_30",
    x1: 212.507,
    y1: 117.991,
    x2: 195.516,
    y2: 114.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B38FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7EFD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01N);
export default __webpack_public_path__ + "static/media/01n.9036ef780561f26590bde547d3316fe1.svg";
export { ForwardRef as ReactComponent };